// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JG4NzLwgl5wJKLclVubW{z-index:var(--zIndex-BASE_9);background:var(--black-50,rgba(0,0,0,.4));border-radius:4px;justify-content:center;align-items:center;display:flex;position:absolute;top:0;bottom:0;left:0;right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `JG4NzLwgl5wJKLclVubW`
};
export default ___CSS_LOADER_EXPORT___;
